import axios from "axios";
import { REACT_APP_QRPOINT_ENDPOINT } from "src/constants";
import StorageService from "src/services/storage/storage.service";

const api = axios.create({
  baseURL: REACT_APP_QRPOINT_ENDPOINT,
});

api.interceptors.request.use(
  (config) => {
    const companyCode = StorageService.getCompanyCode();
    if (companyCode) config.headers["company-code"] = companyCode;
    return config;
  },
  (error) => Promise.reject(error),
);

export default api;
